export const estados = [
    {
        "label": "Aberto",
        "value": "1",
        "color": "warning",
        "colorHEx": "#FFD500"
    },
    {
        "label": "Não Aplicável",
        "value": "2",
        "color": "dark",
        "colorHEx": "#475657"
    },
    {
        "label": "Fechado",
        "value": "3",
        "color": "success",
        "colorHEx": "#5BB25F"
    },
]

export const booleanOptions = [
    {
        "label": "Sim",
        "value": 1
    },
    {
        "label": "Não",
        "value": 0
    }
]

export const locais = [
    {
        "label": "GIMTL",
        "value": 1
    },
    {
        "label": "IGBTL",
        "value": 2
    }
]

export const severidades = [
    {
        "label": "Menor",
        "value": 1,
        "color": "primary"
    },
    {
        "label": "Moderado",
        "value": 2,
        "color": "warning"
    },
    {
        "label": "Sério",
        "value": 3
    },
    {
        "label": "Maior",
        "value": 4
    },
    {
        "label": "Catastrófico",
        "value": 5
    },
    {
        "label": "Desastroso",
        "value": 6
    },
]

export const tipoIncidentes = [
    {
        "label": "Tipo 1",
        "value": 1,
        "color": "primary"
    },
    {
        "label": "Tipo 2",
        "value": 2,
        "color": "warning"
    },
    {
        "label": "Tipo 3",
        "value": 3
    },
]

export const classes = [
    {
        label: "A - Condição ou acto susceptível de causar incapacidade permanente, perda de vida, perda enorme da estrutura ou equipamanto - - Correcção imediata",
        value: "A"
    },
    {
        label: "B - Condição ou acto susceptível de causar incapacidade temporária ou perda de gravidade média da estrutura ou equipamanto",
        value: "B"
    },
    {
        label: "C - Condição ou acto susceptível de causar incapacidade ligeira/pequena gravidade na estrutura ou equipamento",
        value: "C"
    }
]

export const MonthsLabels = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

export const coolors = [
    'rgba(255, 99, 132, 0.2)',
    'rgba(54, 162, 235, 0.2)',
    'rgba(255, 206, 86, 0.2)',
    'rgba(75, 192, 192, 0.2)',
    'rgba(153, 102, 255, 0.2)',
    'rgba(255, 159, 64, 0.2)',
    'rgba(255, 99, 132, 1)',
    'rgba(54, 162, 235, 1)',
    'rgba(255, 206, 86, 1)',
    'rgba(75, 192, 192, 1)',
    'rgba(153, 102, 255, 1)',
    'rgba(255, 159, 64, 1)',
]